module.exports = __webpack_public_path__ + "img/bg.1d2febf0.jpg";